import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActiveGameService } from 'src/app/services/active-game.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    selector: 'app-delete-character-modal',
    templateUrl: './delete-character-modal.component.html',
    styleUrls: ['./delete-character-modal.component.scss'],
    standalone: false
})
export class DeleteGameAndCharacterModalComponent implements OnInit {

  constructor(
    private activeModal: NgbActiveModal,
    private activeGameService: ActiveGameService,
    private toasterService: ToastService,
    private cdr: ChangeDetectorRef
  ) { }

  @Input() character_ids: any[] = [];
  @Input() game_id: any;
  @Input() isAllDisband: boolean;

  ngOnInit(): void {
  }

  disbandPlayers() {
    let characters = this.character_ids.length > 1 ? this.character_ids : this.character_ids[0];
    let payload

    if (this.isAllDisband) {
      payload = {
        game_id: this.game_id
      }
    }
    else {
      payload = {
        game_id: this.game_id,
        character_ids: characters
      }
    }

    this.activeGameService.activeGameCharactersDisband(payload).subscribe((res: any) => {
      this.toasterService.showSuccess(res.message || 'Characters Disbanded Successfully', 'success');
      this.cdr.detectChanges();
      this.closeModal('disbanded')
    }, (err) => {
      this.toasterService.showSuccess(err.error.message || 'Something went wrong. Please try again.', 'danger');
    
          this.cdr.detectChanges();});

  }

  closeModal(result?: any) {
    this.activeModal.close(result);
  }

}
